import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common-service/common.service';
import { KEYS } from'src/app/constants/keys';
import { UploadFaqComponent } from 'src/app/components/modal/upload-faq/upload-faq.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserPageDetails } from 'src/app/models/user-page-details';
import { ColumnHeader } from 'src/app/models/column-header';
import { Labels } from'src/app/constants/labels';
import { SrcPath } from'src/app/constants/srcPath';
import { LoaderService } from 'src/app/services/loader-service/loader.service';
import { ReactiveFormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';
import { ColumnHeaderComponent } from 'src/app/components/column-header/column-header.component';
import { IconBlockSettingsComponent } from 'src/app/components/icon-block-settings/icon-block-settings.component';

@Component({
  selector: 'app-faq',  
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  imports:[ReactiveFormsModule,ColumnHeaderComponent,CommonModule,IconBlockSettingsComponent]
})
export class FaqComponent implements OnInit {
  pageDetails!: UserPageDetails;
  headerData!: ColumnHeader  ;
  faqData: any = [];
  selectedFilesDisp: any = [];
  selectedFilesView: any = [];
  public userdetails: any = [];
  page_id = 0;
  showFaqFlag: boolean = false;
  faqId: any;
  modalRef!: BsModalRef;
  labelMessages = Labels.messages;
  srcPath = SrcPath;
  labelbuttons = Labels.buttons;
  labelIconStyle = Labels.iconStyle;
  siteValue: boolean = false;
  isNotLoading: any;

  constructor(
    private commonService: CommonService,
    public modalService: BsModalService,
    public loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.loaderService.isLoading.subscribe((res:any) => {
      this.isNotLoading = !res;    
    });
    this.pageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
    this.initpageHeader();
    sessionStorage.setItem('moduleName', 'Settings');
    this.commonService.dynamicFaq().subscribe((data: any) => {
      if (data['table']) {
        let nData = data['table'];
        this.faqData = nData;
        if (this.commonService.getUserCredentials(KEYS.credential_site_value) == 'Gusa') {
          this.siteValue = true;
        }
        this.commonService.ogLog('this.faqdata', this.faqData)
      } else {
        this.commonService.ogLog('data not available');
      }

    }, error => {
      console.log('load faq query Error:', error);
    });
    this.commonService.setDashbord(true);
    this.commonService.setUserPage(true);
    this.commonService.setCurrentStaticMenuId(0);
  }

  initpageHeader() {
    this.headerData = {
      title: Labels.title.faq_title,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelbuttons.back_menu,
            icon: SrcPath.previousIcon,
            class: this.labelIconStyle.eleven
          }
        ]
      }
    };
  }

  openModal(faqid: any) {
    this.commonService.setFaqModalData(faqid);
    const config: ModalOptions = { class: KEYS.modalConfigClassXL, backdrop: "static" }
    this.modalRef = this.modalService.show(UploadFaqComponent, config);
  }
}
